import React from 'react';
import updatesData from '../../data/updates.json';
import './Updates.scss';

const Updates = () => {
  return (
    <div className="updates">
      <div className="updates__container">
        <h1 className="updates__title">Updates</h1>
        <p className="updates__subtitle">See what's new in GuessNexus</p>
        
        <div className="updates__timeline">
          {updatesData.map((update, index) => (
            <div key={update.version} className="updates__version">
              <div className="updates__version-header">
                <h2 className="updates__version-number">v{update.version}</h2>
                <span className="updates__version-date">{update.date}</span>
              </div>
              
              <div className="updates__changes">
                {Object.entries(update.changes).map(([category, changeList]) => (
                  <div key={category} className="updates__category">
                    <h3 className="updates__category-title">{category}</h3>
                    <ul className="updates__change-list">
                      {changeList.map((change, changeIndex) => (
                        <li key={changeIndex} className="updates__change-item">
                          {change}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Updates;